import React, { useState } from "react";
import "./Bespock_gift_step_form.css";

import Step_1 from "./step_1/Step_1";
import Step_2 from "./step_2/Step_2";
import Step_3 from "./step_3/Step_3";
import Step_4 from "./step_4/Step_4";
import { Form } from "react-bootstrap";

function Bespock_gift_step_form() {
  const [activeStep, setActiveStep] = useState(1);
  const [draftId, setDraftId] = useState(null); // shared across all steps

  const handleNext = (stepData) => {
    if (stepData?.draftId) {
      setDraftId(stepData.draftId);
    }
    setActiveStep((prev) => (prev < 4 ? prev + 1 : prev));
  };

  const handleBack = () => {
    setActiveStep((prev) => (prev > 1 ? prev - 1 : prev));
  };

  return (
    <>
      <section className="Bespock_gift_step_form">
        <div className="bespock_form_layout">
          {/* LEFT STEPS */}
          <div className="bespock_steps">
            <div className="steps_inner">
              <div
                className={`step_item 
    ${activeStep === 1 ? "active" : ""} 
    ${activeStep > 1 ? "completed" : ""}`}
                // onClick={() => setActiveStep(1)}
              >
                <div className="step_dot_wrap">
                  <span className="step_dot"></span>
                  <span className="step_line"></span>
                </div>
                <div className="step_text">
                  <h4>01</h4>
                  <h4>Customer Information</h4>
                </div>
              </div>

              <div
                className={`step_item 
    ${activeStep === 2 ? "active" : ""} 
    ${activeStep > 2 ? "completed" : ""}`}
                // onClick={() => setActiveStep(2)}
              >
                <div className="step_dot_wrap">
                  <span className="step_dot"></span>
                  <span className="step_line"></span>
                </div>
                <div className="step_text">
                  <h4>02</h4>
                  <h4>Gift Details</h4>
                </div>
              </div>

              <div
                className={`step_item 
    ${activeStep === 3 ? "active" : ""} 
    ${activeStep > 3 ? "completed" : ""}`}
                // onClick={() => setActiveStep(3)}
              >
                <div className="step_dot_wrap">
                  <span className="step_dot"></span>
                  <span className="step_line"></span>
                </div>
                <div className="step_text">
                  <h4>03</h4>
                  <h4>Personalisation Details</h4>
                </div>
              </div>

              <div
                className={`step_item 
    ${activeStep === 4 ? "active" : ""} 
    ${activeStep > 4 ? "completed" : ""}`}
                // onClick={() => setActiveStep(4)}
              >
                <div className="step_dot_wrap">
                  <span className="step_dot"></span>
                </div>
                <div className="step_text">
                  <h4>04</h4>
                  <h4>Order Management</h4>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="bespock_form">
            <Form>
              {activeStep === 1 && <Step_1 handleNext={handleNext} />}
              {activeStep === 2 && (
                <Step_2
                  handleNext={handleNext}
                  draftId={draftId}
                  handleBack={handleBack}
                />
              )}
              {activeStep === 3 && (
                <Step_3
                  handleNext={handleNext}
                  draftId={draftId}
                  handleBack={handleBack}
                />
              )}
              {activeStep === 4 && (
                <Step_4 draftId={draftId} handleBack={handleBack} />
              )}
            </Form>
          </div>
        </div>
      </section>
    </>
  );
}

export default Bespock_gift_step_form;
